import {Navigate, useLocation} from 'react-router-dom'
import {useAppSelector} from '../redux/hooks'
import {appSelector} from '../redux/slices/appSlices'

export const withProtectedRoute = (WrappedComponent: React.ComponentType<any>) => {
  const ProtectedRoute = (props: any) => {
    const {selectedMenu} = useAppSelector(appSelector)
    const {pathname} = useLocation()
    
    if (selectedMenu?.uri !== pathname.slice(1)) {
      // return <Navigate to='/error/404' />
    }

    return <WrappedComponent {...props} />
  }

  return ProtectedRoute
}
